import moment from "moment";
import imageCompression from "browser-image-compression";
import React from "react";
import { invokeExternalApi } from "./axiosHelper";

export const compareString = (item1, item2) => {
  item1 = item1.toUpperCase(); // ignore upper and lowercase
  item2 = item2.toUpperCase(); // ignore upper and lowercase
  if (item1 < item2) {
    return -1;
  }
  if (item1 > item2) {
    return 1;
  }
  // items must be equal
  return 0;
};

export const getFileExtension = (fileName) => {
  const fileNameSplit = fileName.split(".");
  return fileNameSplit[fileNameSplit.length - 1];
};

export const filePreview = (file) => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      resolve(e.target.result);
    };
    reader.onerror = function (error) {
      reject(error);
    };
  });
};

export const fileCompress = async (file, op) => {
  const options = op || {
    maxSizeMB: 1,
    maxWidthOrHeight: 1000,
    useWebWorker: true,
  };
  const blob = await imageCompression(file, options);
  blob.lastModifiedDate = new Date(blob.lastModified);
  return new File([blob], blob.name);
};

export const formatDateTime = (dateTime) => {
  return moment(dateTime).format("DD/MM/YYYY, hh:mm a");
};

export const formatDate = (date) => {
  return moment(date).format("YYYY-MM-DD");
};

export const formatLocalDate = (date) => {
  return moment(date).format("DD-MM-YYYY");
};

export const formatAddress = (address) => {
  const result = (
    <div>
      {address.rcvrName}
      <br />
      {address.address + ", "}
      <br />
      {address.landmark + ", "}
      <br />
      {address.city + " - " + address.pincode}
      <br />
      M. {address.rcvrMobileNo}
    </div>
  );
  return result;
};

export const formatOnlyAddress = (address) => {
  const result =
    address.address +
    ", " +
    address.landmark +
    ", " +
    address.city +
    " - " +
    address.pincode;
  return result;
};

export const formatAddressWithHtml = (address) => {
  return (
    <>
      <div>{address.rcvrName}</div>
      {address.address}, {address.landmark}, {address.city} - {address.pincode}
      <div>Ph: {address.rcvrMobileNo}</div>
    </>
  );
};

export const appendCurrency = (number, numFormat = false) => {
  if (numFormat) {
    number = numberFormat(number);
  }

  return `₹${number}`;
};

export const numberFormat = (number) => {
  number = isNaN(number) ? 0 : number;
  return Number(number).toFixed(2);
};

export const downloadFile = async (fileUrl, fileName) => {
  let data = await invokeExternalApi("GET", fileUrl, "", {
    responseType: "blob",
  });
  if (data) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName); //or any other extension
    document.body.appendChild(link);
    link.click();
  }
};
